/** KW ピッカー用: picker_options.roots を category1 形式へ変換 */
export function mapKwVolumePickerRootsToCategory1(roots) {
  if (!Array.isArray(roots) || roots.length === 0) {
    return [];
  }
  return roots.map((root) => ({
    value: root.value,
    label: root.label || `カテゴリ ${root.value}`
  }));
}

export function createEmptyKwVolumeAmazonCategoryTree() {
  return {
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    category5: [],
    category6: []
  };
}

export function clearKwVolumeAmazonCategoryTreeFromLevel(tree, level) {
  const next = { ...tree };
  for (let i = level; i <= 6; i += 1) {
    next[`category${i}`] = [];
  }
  return next;
}
